import React, { useState, useEffect, useCallback } from 'react'
import { withPlugin } from '@flamingo_tech/funkgo'

import { withModal } from '../../common/Modal/Modal'

import Button from '../../common/Button/Button'
import {
  getPromotionDiscountObject
} from '../../../utils/Store/promotionUtils'
import cx from '../../../utils/className'

import styles from './CiModal.module.css'


const CiModal = props => {
  const ciPopupStorage = props.$storage.create(`ci_popup_${props.ci}`, { expire: 1000 * 60 * 60 * 2 }) // 2h

  const [show, setShow] = useState(false)
  const [coupon, setCoupon] = useState(null)

  const handleCouponChanged = useCallback(() => {
    const coupon = props.$store.couponHub.getAvailableCoupon(props.ci)
    setCoupon(coupon)
  }, [props.$store.couponHub, props.ci])

  useEffect(() => {
    const couponHub = props.$store.couponHub

    couponHub.subscribe(handleCouponChanged)

    return () => {
      couponHub.unsubscribe(handleCouponChanged)
    }

  }, [props.$store.couponHub, handleCouponChanged])


  if (!ciPopupStorage.getItem(false)) { // first popup
    ciPopupStorage.setItem(true)
    setShow(true)

    const coupon = props.$store.couponHub.getAvailableCoupon(props.ci) // 此时可能已经拿到
    setCoupon(coupon)
  }

  return (
    <Modal
      hide={!show || !coupon}
      coupon={coupon}
      $i18n={props.$i18n}
      $site={props.$site}
      $track={props.$track}
      onClose={() => setShow(false)}
    />
  )
}


// 10% 优惠券卡片
const Modal = withModal(props => {

  const { locale } = props.$site.getSiteInfo()
  const isDE = locale === 'de_DE'

  const handleSubmit = () => {
    props.$track.event('CiModal', 'confirm', props.coupon.id)
    props.onClose()
  }

  const handleClose = () => {
    props.$track.event('CiModal', 'close', props.coupon.id)
    props.onClose()
  }

  useEffect(() => {
    props.$track.event('CiModal', 'view', props.coupon.id)
  }, [props.$track, props.coupon.id])

  const { value, off } = getPromotionDiscountObject(props.coupon.meta, props.$i18n, props.$site)

  return (
    <div className={cx(styles.wrapper, isDE && styles.de)}>
      <div className={styles.closeBtn} onClick={handleClose}>&#xe60e;</div>
      <div className={styles.content}>
        <div className={styles.title}>{props.$i18n.transl('core.promotion.ciModal.aboutToExpire')}</div>
        <div className={styles.discount}>
          <div className={styles.value}>{value}</div>
          {
            off &&
            <div className={styles.off}>{off}</div>
          }
        </div>
        <div className={styles.subtitle}>{props.$i18n.transl('core.promotion.ciModal.hurryHint')}</div>
      </div>
      <Button
        className={styles.submitBtn}
        onClick={handleSubmit}>
        {props.$i18n.transl('core.promotion.ciModal.button')}
      </Button>
    </div>
  )
}, { showCloseButton: false, disableCoverClick: true })

export default withPlugin(CiModal)